import { useEffect } from 'react';
import { useParams } from 'react-router';
import TipoGanadoForm from '../../components/tipos-ganado/TipoGanadoForm';
import {
  useTiposGanadoStore,
  type ActualizarTipoGanado
} from '../../stores/tipos-ganado/tipos-ganado.store';

const EditarTipoGanado = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const {
    current: tipo,
    actualizar,
    cargarPorId,
    desactivar,
    activar
  } = useTiposGanadoStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = (values: ActualizarTipoGanado) => {
    return actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <TipoGanadoForm
      tipo={tipo}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
    />
  );
};

export default EditarTipoGanado;
